export const entityRoutes = [
    // Route generiche per tutte le entità
    {
        path: '/:tenantId/entity/:entityType',
        name: 'entity.index',
        component: () => import('@/pages/admin/entity/Index.vue')
    },
    {
        path: '/:tenantId/entity/:entityType/create',
        name: 'entity.create',
        component: () => import('@/pages/admin/entity/Create.vue')
    },
    {
        path: '/:tenantId/entity/:entityType/:id(\\d+)/edit',
        name: 'entity.edit',
        component: () => import('@/pages/admin/entity/Edit.vue')
    }
]

export const legacyEntityFieldRoutes = [
    // Percorso dei campi personalizzati ancora usato da Quote legacy e Ticket.
    {
        path: '/:tenantId/entity/:entityType(account|person|quote|sales_request|ticket)/attributes',
        name: 'entity.attributes.index',
        meta: { legacyEntityFields: true },
        component: () => import('@/pages/admin/legacy-entity-attribute/Index.vue')
    },
    {
        path: '/:tenantId/entity/:entityType(account|person|quote|sales_request|ticket)/attributes/create',
        name: 'entity.attributes.create',
        meta: { legacyEntityFields: true },
        component: () => import('@/pages/admin/legacy-entity-attribute/Create.vue')
    },
    {
        path: '/:tenantId/entity/:entityType(account|person|quote|sales_request|ticket)/attributes/:id(\\d+)/edit',
        name: 'entity.attributes.edit',
        meta: { legacyEntityFields: true },
        component: () => import('@/pages/admin/legacy-entity-attribute/Edit.vue')
    }
]

export const appEntityRoutes = entityRoutes.map(route => ({
    ...route,
    path: route.path.replace('/entity/:entityType', '/apps/:installationKey/:moduleKey'),
    name: `app.${route.name}`,
    meta: { ...route.meta, appEntity: true },
}))

export const appEntityNotFoundRoute = {
    path: '/:tenantId/apps/:appModulePath(.*)*',
    name: 'app-module-not-found',
    component: () => import('@/pages/NotFound.vue'),
}
